import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

// spacer size
var navHeight = $('.nav_mobile_e3f1').height();
if(window.innerWidth < 783) {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight - 46 + 'px'})
} else {
  $('.nav_mobile_e3f1__spacer').css({'height': navHeight + 'px'})
}

function openMenu() {
  $('html, body').css({
    'overflow': 'hidden',
    'height': '100%'
});
  //disableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').addClass('active');
  
  $('.nav_mobile_e3f1').addClass('active');
}

function closeMenu() {
  $('html').css({
    'overflow': 'scroll',
    'height': 'auto'
});
$('html, body').css({
  'height': 'auto'
});
  //enableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').removeClass('active');
  $('.nav_mobile_e3f1').removeClass('active');
}

$('.nav_mobile_e3f1__trigger').on('click', function(e){
  e.preventDefault();
  if($(this).hasClass('active')) {
    closeMenu();
  } else {
    openMenu();
  }
});

$('.nav_mobile_e3f1__menu i').on('click', function(){
  var $li = $(this).parent();
  var id = $li.data('dropdown-mega');
  console.log(id);

  $('.nav_mobile_e3f1__menu').hide();
  $('.sub-menu-' + id).show();
});


$('.main-menu a').on('click', function(e){
  e.preventDefault();

  var $li = $(this);
  var linkto = $li.attr('href');
  var title = $li.text();

  if ($(this).parent().hasClass('menu_has_children')) {
    var $li = $(this).parent();
    var id = $li.data('dropdown-mega');

    $('.nav_mobile_e3f1__menu').hide();
    $('.sub-menu-' + id).show();
  } else {
    var linkHref = $(this).attr('href');
    window.location.href = linkHref;
  }
});

$('.mobile-back').on('click', function(e){
  e.preventDefault();
  
  $('.nav_mobile_e3f1__menu').hide();
  $('.main-menu').show();

});